export default __webpack_public_path__ + "static/media/a7.a384e09a.jpg";